"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillSquare = void 0;
var _SVG = require("../SVG");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BillSquare = _ref => {
  let {
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 48"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M31.868 0c2.865 0 5.209 2.28 5.327 5.126l.005.226v37.296c0 2.876-2.271 5.228-5.107 5.347l-.225.005H5.331C2.467 48 .123 45.72.005 42.874L0 42.648V5.352C0 2.476 2.27.123 5.106.005L5.33 0h26.537Zm0 2.18H5.331a3.17 3.17 0 0 0-3.155 2.986l-.006.186v37.296a3.172 3.172 0 0 0 2.975 3.167l.186.006h26.537a3.17 3.17 0 0 0 3.156-2.987l.006-.186V5.352l-.006-.186a3.172 3.172 0 0 0-2.97-2.981l-.186-.006ZM18.62 28.901l.896.44.002.002c1.611.792 2.882 1.417 2.882 3.402 0 1.653-1.09 2.86-2.85 3.163v.586a.908.908 0 0 1-1.817 0v-.596c-1.727-.318-2.799-1.521-2.799-3.153a.908.908 0 0 1 1.819 0c0 1.297 1.338 1.438 1.914 1.438.575 0 1.915-.14 1.915-1.438 0-.835-.296-1.007-1.869-1.779l-.897-.443c-1.611-.79-2.883-1.415-2.883-3.401 0-1.603 1.097-2.841 2.8-3.17v-.58a.909.909 0 0 1 1.817 0v.569c1.736.307 2.81 1.52 2.81 3.18a.909.909 0 0 1-1.818 0c0-1.316-1.313-1.458-1.876-1.458-.32 0-1.914.07-1.914 1.459 0 .834.295 1.006 1.868 1.779Zm8.215-18.169H10.498c-.495 0-.898.479-.898 1.067s.403 1.067.899 1.067h16.336c.495 0 .898-.479.898-1.067s-.403-1.067-.898-1.067Zm-16.337 5.334h16.337c.495 0 .898.478.898 1.066 0 .589-.403 1.067-.898 1.067H10.498c-.495 0-.898-.478-.898-1.067 0-.588.403-1.066.899-1.066Z",
    clipRule: "evenodd"
  }));
};
exports.BillSquare = BillSquare;
BillSquare.displayName = "BillSquare";